<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ri16OF/tc-custom/9780813138725.jpg?1701315821746" alt="This image is the cover for the book Black Greek-Letter Organizations in the 21st Century"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Greek-Letter Organizations in the 21st Century
      </h1>
      <p class="bookDescription body article font2">
        <b>“A masterpiece of multidisciplinary scholarship that clearly demonstrates the contemporary relevance of black fraternities and sororities.” —Hasan Kwame Jeffries, author of <i>Bloody Lowndes</i></b><br/><br/>During the twentieth century, black Greek-Letter organizations (BGLOs) united college students dedicated to excellence, fostered kinship, and uplifted African Americans. Members of these organizations include remarkable and influential individuals such as Martin Luther King Jr., Congresswoman Barbara Jordan, novelist Toni Morrison, and Wall Street pioneer Reginald F. Lewis. Despite the profound influence of these groups, many now question the continuing relevance of BGLOs, arguing that their golden age has passed.<br/><br/>To foster a greater engagement with the history and contributions of BGLOs, <i>Black Greek-Letter Organizations in the Twenty-first Century</i> brings together an impressive group of authors to explore the contributions and continuing possibilities of BGLOs and their members. Editor Gregory S. Parks and the contributing authors provide historical context for the development of BGLOs, exploring their service activities as well as their relationships with other prominent African American institutions. Both internally and externally, BGLOs struggle to forge a relevant identity for the new century. Internally, these groups wrestle with many issues, including hazing, homophobia, petty intergroup competition, and the difficulty of bridging the divide between college and alumni members. Externally, BGLOs face the challenge of rededicating themselves to their communities and leading an aggressive campaign against modern forms of racism, sexism, and other types of fear-driven behavior.<br/><br/>By embracing the history of these organizations and exploring their continuing viability and relevance, <i>Black Greek-Letter Organizations in the Twenty-first Century</i> demonstrates that BGLOs can create a positive and enduring future and that their most important work lies ahead.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gregory S. Parks, Julianne Malveaux, Marc H. Morial
      </h2>
      
      <p class="authorDescription body article">Gregory S. Parks is a member of Alpha Phi Alpha Fraternity and the editor of four books including Black Greek-Letter Organizations in the 21st Century: Our Fight Has Just Begun; Critical Race Realism: Intersections of Psychology, Race, and Law; and Brothers and Sisters: Diversity in American College Fraternities and Sororities,.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e8e1bac